import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { pender } from 'redux-pender';
import * as api from 'app/api';

const INIT = 'homeservice.estimate/INIT';
export const init = createAction(INIT);

const GET_ESTIMATE = 'homeservice.estimate/GET_ESTIMATE';
export const getEstimate = createAction(GET_ESTIMATE, api.getEstimate);

const GET_PAYMENT_ESTIMATE = 'homeservice.estimate/GET_PAYMENT_ESTIMATE';
export const getPaymentEstimate = createAction(GET_PAYMENT_ESTIMATE, api.getPaymentEstimates);

const GET_HOMESERVICE_ESTIMATE = 'homeservice.estimate/GET_HOMESERVICE_ESTIMATE';
export const getHomeServiceEstimate = createAction(GET_HOMESERVICE_ESTIMATE, api.getHomeServiceEstimate);

const initialState = {
	init: false,
	estimateInfo: {},

	// 결제 필요 금액 확인 :: h3, estimate store와 동일
	paymentEstimateInfo: {
		appliedCoupons: [],
		totalDiscountAmount: 0,
		carPrice: 0,
		transferCost: 0,
		transferAgencyFee: 0,
		onlineVehicleTransferAgencyFee: 0,
		sellingCost: 0,
		consignmentFee: 0,
		consignmentFeeByStarting: [], // 탁송비 구간(출발지로만)
		userFee: 0,
		extendedWarrantyCost: 0,
		extendedWarrantyMonth: 0,
		sellerFee: 0,
		completedPaymentAmount: 0,
		encarPayLoan: {
			loanAmount: 0,
			downPayment: 0,
			loanLimitGap: 0,
		},
		encarLoan: {
			loanAmount: 0,
		},
		liabilityInsuranceFee: 0,
		total: 0,
	},
};

export default handleActions(
	{
		[INIT]: (state) =>
			produce(state, (draft) => {
				draft.init = true;

				return draft;
			}),

		...pender({
			type: GET_ESTIMATE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.estimateInfo = data;

					return draft;
				}),
		}),

		...pender({
			type: GET_PAYMENT_ESTIMATE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.paymentEstimateInfo = data;

					return draft;
				}),
		}),

		...pender({
			type: GET_HOMESERVICE_ESTIMATE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.paymentEstimateInfo = data;
					draft.init = true;

					return draft;
				}),
		}),
	},
	initialState,
);
